import { FC, memo } from 'react';
import { iFixitHotSpotItem } from '../Generic/iFixitHotSpotItem';
import { Flex, FlexProps, ListItem, ListProps, UnorderedList } from '@chakra-ui/react';
import { WithRequiredProps } from '../Generic/requireProps';

export const PartsList = memo(function PartsListInternal({
   data,
   PartRow,
   ...props
}: {
   data: iFixitHotSpotItem[];
   PartRow: FC<{ datapoint: iFixitHotSpotItem }>;
} & ListProps) {
   const parts = data.map(datapoint => (
      <ListItem
         key={datapoint.id}
         position="static"
         margin="0"
         padding="0"
         background="#ffffff"
         _even={{ background: 'gray.50' }}
         sx={{
            '&&': {
               margin: '0',
               left: '0',
               width: '100%',
            },
         }}
      >
         <PartRow datapoint={datapoint} />
      </ListItem>
   ));

   return (
      <UnorderedList
         margin="0"
         padding="0"
         listStyleType="none"
         overflow="auto"
         borderRadius="md"
         sx={{
            '&&': {
               margin: '0',
            },
         }}
         {...props}
      >
         {parts}
      </UnorderedList>
   );
});

type PartListContainerProps = WithRequiredProps<FlexProps, 'marginRight' | 'marginTop'>;
export function PartListContainer({
   marginRight,
   marginTop,
   children,
   ...props
}: PartListContainerProps) {
   return (
      <Flex
         direction="column"
         boxShadow="2xl"
         borderRadius="md"
         position="fixed"
         zIndex={9999}
         top={0}
         right={0}
         marginRight={marginRight}
         marginTop={marginTop}
         backgroundColor="gray.50"
         borderLeftWidth={1}
         borderColor="gray.300"
         maxWidth={`calc(100% - (2 * ${marginRight}))`}
         minHeight="200px"
         {...props}
      >
         {children}
      </Flex>
   );
}
